import {NgModule} from '@angular/core'
import {HeroCoverComponent} from './hero-cover.component'
import {HeroCallToActionSectionComponent} from './hero-call-to-action/hero-call-to-action-section.component'
import {HeroCallToActionComponent} from './hero-call-to-action/hero-call-to-action.component'
import {CommonModule, NgOptimizedImage} from '@angular/common'
import {HeroMobiliarPartnershipComponent} from './hero-mobiliar-partnership/hero-mobiliar-partnership.component'
import {HeroFormComponent} from './hero-form/hero-form.component'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {HeroPartnershipComponent} from './hero-partnership/hero-partnership.component'
import {DirectivesModule} from '../../directives/directives.module'
import {BrandingModule} from '../branding/branding.module'
import {TranslocoModule} from '@ngneat/transloco'
import {SellingPointBarModule} from '../../../craft/selling-point-bar/selling-point-bar.module'
import {RatingModule} from '../../../craft/rating/rating.module'
import {ButtonModule} from '../../../craft/button/button.module'
import {DynamicIconModule} from '../../../craft/dynamic-icon/dynamic-icon.module'
import {WaveCoverImageModule} from '../../../craft/wave-cover-image/wave-cover-image.module'
import {RecommendedByComponent} from '../../../craft/recommended-by/recommended-by.component'
import {GoogleRatingComponent} from '../../../craft/google-rating/google-rating.component'
import {ListModule} from '../../../craft/list/list.module'
import {HeroSearchComponent} from './hero-search/hero-search.component'
import {HeroTagsComponent} from './hero-tags/hero-tags.component'
import {RouterLink} from '@angular/router'

@NgModule({
  declarations: [
    HeroCoverComponent,
    HeroPartnershipComponent,
    HeroCallToActionSectionComponent,
    HeroCallToActionComponent,
    HeroMobiliarPartnershipComponent,
    HeroFormComponent,
    HeroSearchComponent,
    HeroTagsComponent,
  ],
  exports: [
    HeroCoverComponent,
    HeroCallToActionComponent,
    HeroCallToActionSectionComponent,
    HeroPartnershipComponent,
    HeroMobiliarPartnershipComponent,
    HeroFormComponent,
    HeroSearchComponent,
    HeroTagsComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    DirectivesModule,
    BrandingModule,
    WaveCoverImageModule,
    TranslocoModule,
    SellingPointBarModule,
    RatingModule,
    ButtonModule,
    DynamicIconModule,
    NgOptimizedImage,
    RecommendedByComponent,
    GoogleRatingComponent,
    ListModule,
    RouterLink,
  ],
})
export class HeroCoverModule {}
